import Vue from 'vue'
import VueResource from 'vue-resource'
import { orderBy } from 'lodash-es'

Vue.use(VueResource)

export default {
    fillSourceTypes (context) {
        Vue.http.get(
            context.getters.endpoint + '/db/list', {
                emulateJSON: true,
                params: {kind: 'source_types'},
                headers: context.getters.secureHeaders
            }).then((n) => {
            if (n.body.result) {
                context.commit('setSourceTypes', orderBy(n.body.data, "source_type_provider", "asc"))
            } else {
                console.log(n.body)
            }
        });
    },
    fillDataSourceTypes (context) {
        Vue.http.get(
            context.getters.endpoint + '/db/list', {
                emulateJSON: true,
                params: {kind: 'data_source_types'},
                headers: context.getters.secureHeaders
            }).then((n) => {
            if (n.body.result) {
                context.commit('setDataSourceTypes', orderBy(n.body.data, "id", "name"))
            } else {
                console.log(n.body)
            }
        });
    },
    fillSegments (context) {
        Vue.http.get(
            context.getters.endpoint + '/db/list', {
                emulateJSON: true,
                params: {kind: 'segments'},
                headers: context.getters.secureHeaders
            }).then((n) => {
            if (n.body.result) {
                context.commit('setSegments', orderBy(n.body.data, "segment_name", "asc"))
            } else {
                console.log(n.body)
            }
        });
    },
    fillVerticals (context) {
        Vue.http.get(
            context.getters.endpoint + '/db/list', {
                emulateJSON: true,
                params: {kind: 'verticals'},
                headers: context.getters.secureHeaders
            }).then((n) => {
            if (n.body.result) {
                context.commit('setVerticals', orderBy(n.body.data, "vertical_name", "asc"))
            } else {
                console.log(n.body)
            }
        });
    }
}
